import FootballState from "../../../../../sports/football/state/football-state";
import { TackleFragmentSerializer } from "./TackleFragmentSerializer";

export class PassBrokenUpFragmentSerializer extends TackleFragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.PassBrokenUp;
    }

    getRawFragment(play, serializationContext, passBrokenUp) {
        return this.getRawFragmentForState(
            play,
            serializationContext,
            FootballState.PassBrokenUp,
            passBrokenUp
        );
    }
}
